import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	errorMessage: {
		id: 'eoc.error-boundary.default-fallback',
		defaultMessage: 'Something went wrong!',
		description:
			'The text will be displayed when error occurred in the component which was wrapped by ErrorBoundary',
	},
});
